import Api from '../Api';

import { url } from './config';
import { Role } from './types';

const api = new Api<Role>(url);

export default api;
